<template>
  <div class="shop">
    <div
      class="notify fade"
      v-if="notification"
      :class="notification_type"
      @click="notification=false"
    >{{notification}}</div>
    <div class="container is-boxed-fluid fullscreen-content">
      <div class="products">
        <h1 class="section-title centered" v-if="favorite.products.length!=0">FAVORITES</h1>
        <div class="row">
          <div class="col-12">
            <div class="products-not-found" v-show="!page.loading && favorite.products.length==0">
              Your favorites is empty
              <div>
                <router-link :to="{name: 'shop'}" class="reset-filters">Go to shop</router-link>
              </div>
            </div>
            <div class="row fade" v-show="!page.loading">
              <div class="col-3 col-md-12" v-for="(product, key) in favorite.products" :key="key">
                <product :item="product"></product>
              </div>
            </div>
            <div class="row fade load-products" v-show="page.loading">
              <div class="col-3 col-md-12">
                <div class="loading"></div>
              </div>
              <div class="col-3 col-md-12">
                <div class="loading"></div>
              </div>
              <div class="col-3 col-md-12">
                <div class="loading"></div>
              </div>
              <div class="col-3 col-md-12">
                <div class="loading"></div>
              </div>
              <div class="col-3 col-md-12">
                <div class="loading"></div>
              </div>
              <div class="col-3 col-md-12">
                <div class="loading"></div>
              </div>
              <div class="col-3 col-md-12">
                <div class="loading"></div>
              </div>
              <div class="col-3 col-md-12">
                <div class="loading"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product from '@/components/items/Product.vue';
import Api from '@/services/api-service';
import { mapState } from 'vuex';

export default {
  components: {
    Product
  },
  data () {
    return {
      products: [],
      interval: null,
      notification: false,
      notification_type: 'success',
      notification_timeout: null
    }
  },
  methods: {
    notify (notification, type = 'success', time = 1500) {
      var self = this
      self.notification = notification
      self.notification_type = type
      clearTimeout(this.notification_timeout)
      self.notification_timeout = setTimeout(function () {
        self.notification = false
      }, time)
    }
  },
  created () {
    this.$store.dispatch('fetchLoading', true)
    Api.post('/data/favorites', {
      data: this.favorite.items
    })
      .then(response => {
        if (response.data.page.status != 404) {
          var t = this
          t.$store.dispatch(
            'fetchFavorites',
            response.data.page.response.products
          )
          if (this.interval) {
            clearInterval(this.interval)
          }
          this.interval = setTimeout(function () {
            t.$store.dispatch('fetchLoading', false)
          }, 1000)
        } else {
          this.$router.push({ name: '404' })
        }
      })
      .catch(error => {
        console.log(error)
        //this.$Progress.fail()
        console.log('There was an error:', error.response)
      })
  },
  computed: mapState(['page', 'favorite'])
}
</script>
